export default function ssoLogin(email: string) {
  return fetch(`${window.graphqlEndpoint}/auth/authenticate_by_sso`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  }).then((response) => response.json())
}
